<template>
  <div class="rating-container">
    <!-- <img :src="getImage('star')" class="w-48 mb-10 pulsing"> -->
    <LabelControl type="dynamic" class="text-grey-darker font-bold text-5xl mb-2" :content="$t('msg004')" />
    <div class="stars">
      <svg v-for="star in 5" :key="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="star"
        :class="{ active: star <= selected_rating }" @click="selectRating(star)">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22l1.18-7.86-5-4.87 6.91-1.01L12 2z" />
      </svg>
    </div>

    <p class="text-grey-dark text-2xl font-bold mb-5 mt-12">
      {{ selected_rating < 5 ? $t('msg018') : $t('msg017') }} </p>

        <!-- Improvement Category Selection -->
        <div class="flex flex-wrap text-2xl justify-center items-center" style="gap: 1rem; width: 50rem;">
          <div v-for="(category, index) in categories" :key="index" @click="toggleCategory(category)"
            class="px-6 py-3 rounded-full cursor-pointer transition-all font-medium"
            :class="{ 'bg-warning-light text-warning-dark': selected_categories.includes(category), 'bg-grey-lighter text-grey-dark': !selected_categories.includes(category) }">
            {{ category }}
          </div>
        </div>

        <div class="flex flex-row justify-center align-center items-center w-full mt-6" style="gap: 2rem;">
          <ButtonControl class="w-full" :text="$t('msg005')" theme="warning_secondary"
            @click="$emit('cancel-rating')" />

          <ButtonControl 
            class="w-full" 
            :disabled="isSubmitDisabled || submitting_rating" 
            @click="submitRating" 
            :button_loading="submitting_rating"
            :text="$t('btn008')" 
            theme="warning" />

        </div>


  </div>

  <!-- Existing Session -->
  <transition name="slide-in">
    <ModalControl :is_visible="existing_session">
      <SessionTimeoutControl />
    </ModalControl>
  </transition>
</template>

<script>
import mixin from '@/mixins/controls.js';
import user from '@/services/user';
import ButtonControl from './ButtonControl.vue';
import ModalControl from './ModalControl.vue';
import LabelControl from './LabelControl.vue';
import SessionTimeoutControl from './SessionTimeoutControl.vue';

export default {
  name: "v-modal",
  mixins: [mixin],
  inject: ['setLoading', 'setError'],
  emits: ['rating-submitted', 'cancel-rating'],
  components: {
    ButtonControl,
    ModalControl,
    SessionTimeoutControl,
    LabelControl
  },
  props: {
    isLogoutRating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected_rating: 5,
      previous_rating: 5,
      selected_categories: [],
      categories: ['Connectivity', 'Accuracy', 'Convenience', 'Reliability', 'Ease of Use', 'Security', 'Accessibility'], // Improvement categories
      is_submitted: false,
      hash: this.$store.state.user.hash,
      uuid: this.$store.state.user.uuid,
      kiosk_id: this.$store.state.branch.kiosk_id,
      existing_session: false,
      submitting_rating: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      if (this.selected_rating === 0) return true;
      if (this.selected_rating < 5 && this.selected_categories.length === 0) return true;
      return false;
    }
  },
  methods: {
    hoverRating(score) {
      if (!this.is_submitted) {
        this.selected_rating = score;
      }
    },
    selectRating(score) {
      if (!this.is_submitted) {
        const wasFive = this.previous_rating === 5;
        const isFive = score === 5;

        if (wasFive !== isFive) {
          // Rating crossed the 5 <-> 1-4 boundary
          this.selected_categories = [];
        }

        this.selected_rating = score;
        this.previous_rating = score;
      }
    },
    toggleCategory(category) {
      const index = this.selected_categories.indexOf(category);
      if (index === -1) {
        this.selected_categories.push(category);
      } else {
        this.selected_categories.splice(index, 1);
      }
    },
    submitRating() {
        this.is_submitted = true;
        this.submitting_rating = true;
        const remarks = JSON.stringify(this.selected_categories);
        user.submitRating(this.hash, 3, this.selected_rating, this.uuid, this.kiosk_id, remarks)
        .then(() => {
          this.$emit('rating-submitted', this.selected_rating);
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
              this.resetUserData();
              this.clearUserCookie();
              this.toggleExistingSessionModal();
              this.setLoading(false);
            }
            console.error('Error submitting rating:', error);
          })
          .finally(() => {
            this.is_submitted = false;
            this.submitting_rating = false;
          });
    }
  },
};
</script>


<style scoped>
.rating-container {
  text-align: center;
}

.stars {
  font-size: 4rem;
  display: flex;
  justify-content: center;
  color: #d3d3d3;
  margin-top: 1rem;
}

.star {
  width: 6rem;
  /* Adjust size */
  height: 6rem;
  margin: 0 0.2rem;
  fill: #d3d3d3;
  /* Default color for inactive stars */
  cursor: pointer;
  transition: fill 0.2s;
}

.star.active {
  fill: #FFC107;
  /* Gold color for active stars */
}

.pulsing {
  display: inline-block;
  /* Ensure the element has a size */
  animation: pulse 1.5s infinite ease-in-out;
  /* Adjust duration as needed */
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.9);
    /* Shrink */
  }

  100% {
    transform: scale(1);
    /* Back to original size */
  }
}
</style>